import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_project_action_notificator = _resolveComponent("project-action-notificator")
  const _component_backer_center_pledge_card_header = _resolveComponent("backer-center-pledge-card-header")
  const _component_order_statuses_list = _resolveComponent("order-statuses-list")
  const _component_backer_center_pledge_card_additional_info = _resolveComponent("backer-center-pledge-card-additional-info")
  const _component_pledge_payment_history_modal = _resolveComponent("pledge-payment-history-modal")
  const _component_order_stage_history_modal = _resolveComponent("order-stage-history-modal")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", {
    class: "_pos-r",
    "data-qa": `project-engagement-card-ID:${$props.orderID}`
  }, [
    _createVNode(_component_balloon_actions, {
      class: "gfu-box__balloon _z-1",
      actions: $options.balloonActions,
      "balloon-style-props": $options.balloonStyleProps,
      theme: "lightOutline",
      mode: _ctx.balloonActionsModes.grouped,
      "data-qa": "pledge-card:Actions"
    }, null, 8 /* PROPS */, ["actions", "balloon-style-props", "mode"]),
    _createVNode(_component_box, { mute: $options.isMuted }, {
      default: _withCtx(() => [
        ($options.hasAction)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.mappedActions, (action) => {
              return (_openBlock(), _createBlock(_component_project_action_notificator, _mergeProps({
                key: action.actionLabel
              }, { ref_for: true }, action, { onActionDismiss: $options.handleActionDismiss }), null, 16 /* FULL_PROPS */, ["onActionDismiss"]))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_backer_center_pledge_card_header, _normalizeProps(_guardReactiveProps({..._ctx.$props})), null, 16 /* FULL_PROPS */),
        _createVNode(_component_order_statuses_list, {
          "order-stage": $props.stage,
          "payment-status": $props.paymentStatus,
          "project-phase": $props.projectPhase,
          class: "_my-3"
        }, null, 8 /* PROPS */, ["order-stage", "payment-status", "project-phase"]),
        _createVNode(_component_backer_center_pledge_card_additional_info, _normalizeProps(_guardReactiveProps({..._ctx.$props})), null, 16 /* FULL_PROPS */),
        (_ctx.isPaymentHistoryModalOpen)
          ? (_openBlock(), _createBlock(_component_pledge_payment_history_modal, {
              key: 1,
              "is-open": _ctx.isPaymentHistoryModalOpen,
              "order-id": $props.orderID,
              "pledge-id": $props.orderPublicID,
              onActionClose: $options.onPaymentHistoryModalClose
            }, null, 8 /* PROPS */, ["is-open", "order-id", "pledge-id", "onActionClose"]))
          : _createCommentVNode("v-if", true),
        (_ctx.isOrderStageHistoryModalOpen)
          ? (_openBlock(), _createBlock(_component_order_stage_history_modal, {
              key: 2,
              "is-open": _ctx.isOrderStageHistoryModalOpen,
              "order-public-id": $props.orderPublicID,
              "order-id": $props.orderID,
              onActionClose: $options.onOrderStageHistoryModalClose
            }, null, 8 /* PROPS */, ["is-open", "order-public-id", "order-id", "onActionClose"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["mute"])
  ], 8 /* PROPS */, _hoisted_1))
}